export default "__VITE_ASSET__3372200f__"